import type {RouterOptions} from 'vue-router';

export default <RouterOptions>{
  // scrollBehavior: () => ({left: 0, top: 0}),
};
